import React, { Component } from 'react';
import isNil from 'lodash/isNil';
import { Grid } from '@mui/material';
import { DefaultsTypes } from 'js/constants/schemaEditor';
import {
  SelectInput,
  SelectOption,
  getCurrentSelectedOption,
  getNewSelectionValue,
} from '../../rselect/ReactSelectUtils';
import UnsortedSelect from '../../rselect/UnsortedSelect';
import { map } from 'lodash';
import { TextField } from 'new/elements/TextField';

class InspectorDefault extends Component {
  _handleAttributeChanged = (newAttr) => {
    const { defaultData, onDefaultChanged } = this.props;
    const attr = getNewSelectionValue(newAttr, true, '');

    onDefaultChanged({ ...defaultData, __destAttr: attr });
  };

  _handleDefaultTypeChanged = (newDefaultSelection) => {
    const { defaultData, onDefaultChanged } = this.props;
    const {
      parameters: { value },
    } = defaultData;
    const newType = getNewSelectionValue(newDefaultSelection, true, DefaultsTypes.DEFAULT_NONE);

    // let newType =
    //   isNil(newDefaultSelection) || !has(newDefaultSelection, 'value')
    //     ? DefaultsTypes.DEFAULT_NONE
    //     : newDefaultSelection.value;

    let newValue = value;
    if (!isNil(newDefaultSelection) && newDefaultSelection.needsVal === false) {
      newValue = null;
    }

    onDefaultChanged({
      ...defaultData,
      parameters: {
        ...defaultData.parameters,
        defaultType: newType,
        value: newValue,
      },
    });
  };

  _handleDefaultValueChanged = (newDefaultValue) => {
    const { defaultData, onDefaultChanged } = this.props;
    onDefaultChanged({
      ...defaultData,
      parameters: { ...defaultData.parameters, value: newDefaultValue },
    });
  };

  render() {
    const {
      defaultData: {
        parameters: { defaultType, value },
        __destAttr,
      },
      displayOptions,
      outputSchema,
      isReadOnly,
    } = this.props;
    const attributeOptions = map(outputSchema, (attr) => ({
      label: attr.__txName,
      value: attr.__txName,
    }));
    const selectedAttribute = getCurrentSelectedOption(
      attributeOptions,
      __destAttr,
      null,
      null,
      true,
    );
    const selectedDefaultType = getCurrentSelectedOption(displayOptions, defaultType);

    return (
      <div className="inspector-default">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Grid container>
            <Grid item xs={4}>
              <UnsortedSelect
                isCreatable={true}
                options={attributeOptions}
                components={{ Input: SelectInput, Option: SelectOption }}
                backspaceRemovesValue={false}
                isClearable={false}
                isSearchable={true}
                isDisabled={isReadOnly}
                value={selectedAttribute}
                variant="default"
                onChange={this._handleAttributeChanged}
              />
            </Grid>
            <Grid item xs={4}>
              <div style={{ paddingLeft: 'var(--spacing-md)' }}>
                <UnsortedSelect
                  placeholder="Type to select"
                  options={displayOptions}
                  components={{ Input: SelectInput, Option: SelectOption }}
                  backspaceRemovesValue={false}
                  isClearable={false}
                  isSearchable={true}
                  isDisabled={isReadOnly}
                  name="select"
                  value={selectedDefaultType}
                  variant="default"
                  onChange={this._handleDefaultTypeChanged}
                />
              </div>
            </Grid>
            {selectedDefaultType?.needsVal && (
              <Grid item xs={4}>
                <div style={{ paddingLeft: 'var(--spacing-md)' }}>
                  <TextField
                    variant="filled"
                    style={{ background: 'white' }}
                    value={isNil(value) ? '' : String(value)}
                    disabled={isReadOnly}
                    onChange={(event) => this._handleDefaultValueChanged(event.target.value)}
                  />
                </div>
              </Grid>
            )}
          </Grid>
        </div>
      </div>
    );
  }
}

export default InspectorDefault;
